var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gf-button-subscribe',{attrs:{"stars-count":parseInt(_vm.starsCount),"is-starred":_vm.isStarred},on:{"star":_vm.starTeam}})
}
var staticRenderFns = []

export { render, staticRenderFns }